<template>
  <v-container fluid grid-list-sm>
    <v-row>
      <v-col cols="12" sm="9">
        <h3 class="display-1 primary--text">Estimates</h3>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn @click="launchModal" x-large class="float-right" color="primary" fab icon>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field v-on:click:clear="clearSearch" :loading="isLoading" v-debounce:500ms="searchForEstimate"
                      label="Search for estimate" v-model="search" clearable/>
      </v-col>
      <v-col cols="12" sm="12">
        <v-data-table :loading="isLoading" :headers="headers" :items="estimates" class="elevation-1 mt-5">
          <template v-slot:item.customer.vrm="{item}">
            <span v-if="item.customer && item.customer.vrm" class="vrm"> {{ item.customer.vrm }} </span><span
              v-else>N/A</span>
          </template>
          <template v-slot:item.estimateDate="{item}">
            <span> {{ item.estimateDate | moment('DD/MM/YYYY') }} </span>
          </template>
          <template v-slot:item.estimateExpiry="{item}">
            <span> {{ item.estimateExpiry | moment('DD/MM/YYYY') }} </span>
          </template>
          <template v-slot:item.total="{item}">
            <span> £{{ item.total | amount }} </span>
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn class="mr-2" :loading="isEmailing" :disabled="isEmailing" icon>
              <v-icon large style="cursor: pointer" color="primary" @click="emailEstimate(item)">mdi-mail</v-icon>
            </v-btn>
            <v-btn class="mr-2" :loading="isGenerating" :disabled="isGenerating" icon>
              <v-icon large style="cursor: pointer" color="success" @click="printEstimate(item)">mdi-printer</v-icon>
            </v-btn>
            <v-icon large style="cursor: pointer" color="primary" class="mr-2" @click="viewEstimate(item)">mdi-magnify
            </v-icon>
            <v-icon large style="cursor: pointer" color="secondary" class="mr-2" @click="createBooking(item)">
              mdi-calendar
            </v-icon>
            <v-icon large color="info" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon large color="error" @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" sm="9">
        <h3 class="display-1 primary--text">Drafts</h3>
      </v-col>
      <v-col cols="12" sm="12">
        <v-data-table :loading="isLoading" :headers="headers" :items="drafts" class="elevation-1 mt-5">
          <template v-slot:item.customer.vrm="{item}">
            <span v-if="item.customer && item.customer.vrm" class="vrm"> {{ item.customer.vrm }} </span><span
              v-else>N/A</span>
          </template>
          <template v-slot:item.estimateDate="{item}">
            <span> {{ item.estimateDate | moment('DD/MM/YYYY') }} </span>
          </template>
          <template v-slot:item.estimateExpiry="{item}">
            <span> {{ item.estimateExpiry | moment('DD/MM/YYYY') }} </span>
          </template>
          <template v-slot:item.total="{item}">
            <span> £{{ item.total | amount }} </span>
          </template>
          <template v-slot:item.actions="{item}">
            <v-icon large color="info" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon large color="error" @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="showSelectSubEstimateDialog" width="50%" persistent>
      <v-card>
        <v-card-title>This estimate has different options, select which estimate to use</v-card-title>
        <v-card-text>
          <v-checkbox label="Use Primary estimate" v-model="usePrimary" />
          <v-select v-if="!usePrimary" v-model="subEstimateToUse" label="Choose Sub Estimate" return-object item-text="name" :items="subEstimateList" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showSelectSubEstimateDialog = false">Cancel</v-btn>
          <v-btn color="success" @click="selectSubEstimate">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {EstimatesHttp} from "../../http/estimates";
import {EventBus} from "../../EventBus";

export default {
  name: "Estimates",
  methods: {
    viewEstimate(item) {
      this.$router.push(`/estimate/${item._id}`);
    },
    async printEstimate(item) {
      this.isGenerating = true;
      const blob = await EstimatesHttp.printEstimate(item._id);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      window.open(link.href, '_blank');
      this.isGenerating = false;
    },
    async emailEstimate(item) {
      this.isEmailing = true;
      try {
        await EstimatesHttp.emailEstimate(item._id);
        EventBus.$emit('message', {message: 'Email sent Successfully', type: 'success'});
      } catch (e) {
        EventBus.$emit('message', {message: e.message, type: 'error'});
      } finally {
        this.isEmailing = false;
      }
    },
    launchModal() {
      this.$store.dispatch('estimates/resetActiveEstimate');
      this.$store.dispatch('estimates/setManageEstimateDialog', true);
    },
    editItem(item) {
      this.$store.dispatch('estimates/setActiveEstimate', item);
      this.$store.dispatch('estimates/setManageEstimateDialog', true);
    },
    deleteItem(item) {
      this.$store.dispatch('estimates/setActiveEstimate', item);
      this.$store.dispatch('estimates/setDeleteEstimateDialog', true);
    },
    async searchForEstimate() {
      if (this.search.length > 3) {
        this.isLoading = true;
        await this.$store.dispatch('estimates/searchForEstimates', this.search);
        this.isLoading = false;
      }
    },
    clearSearch() {
      this.$store.dispatch('estimates/setEstimates');
    },
    createBooking(item) {
      if (item.subEstimates && item.subEstimates.length > 0) {
        this.subEstimateList = item.subEstimates;
        this.theItem = item;
        this.showSelectSubEstimateDialog = true;
      } else {
        this.$store.dispatch('estimates/setActiveEstimate', item);
        const newBooking = {...item};
        newBooking.dailyTotals = [];
        delete newBooking._id;
        this.$store.dispatch('bookings/setActiveBooking', newBooking);
        this.$store.dispatch('bookings/setManageBookingDialog', true);
      }
    },
    selectSubEstimate() {
      if (!this.usePrimary) {
        this.theItem.total = this.subEstimateToUse.total;
        this.theItem.damage = this.subEstimateToUse.damage;
        this.theItem.parts = this.subEstimateToUse.parts;
        this.theItem.isPdr = this.subEstimateToUse.isPdr;
        this.theItem.pdrAmount = this.subEstimateToUse.pdrAmount;
        this.theItem.isAlloys = this.subEstimateToUse.isAlloys;
        this.theItem.alloyTypes = this.subEstimateToUse.alloyTypes;
      }
      this.$store.dispatch('estimates/setActiveEstimate', this.theItem);
      const newBooking = {...this.theItem};
      newBooking.dailyTotals = [];
      delete newBooking._id;
      this.$store.dispatch('bookings/setActiveBooking', newBooking);
      this.$store.dispatch('bookings/setManageBookingDialog', true);
    }
  },
  computed: {
    estimates: {
      get() {
        return this.$store.state.estimates.estimates;
      }
    },
    drafts: {
      get() {
        return this.$store.state.estimates.drafts;
      }
    }
  },
  data() {
    return {
      headers: [
        {text: 'Customer', value: 'customer.name'},
        {text: 'Make', value: 'customer.make'},
        {text: 'Estimate Date', value: 'estimateDate'},
        {text: 'Estimate Expires', value: 'estimateExpiry'},
        {text: 'VRM', value: 'customer.vrm'},
        {text: 'Total', value: 'total'},
        {text: 'Actions', value: 'actions'}
      ],
      search: '',
      isLoading: false,
      isGenerating: false,
      isEmailing: false,
      showSelectSubEstimateDialog: false,
      usePrimary: true,
      subEstimateToUse: {},
      theItem: {},
      subEstimateList: []
    }
  }
}
</script>

<style scoped>

</style>
